import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import EditInverterStrings from "./EditInverterStrings";
import { InverterDetails } from "../types";

interface EditInvertersStringsContainerProps {
    invertersAmount: number;
    totalStrings: number;
    firstInverterNumber: number;
    inverterDetails?: Record<string, InverterDetails>;
    isEditing: boolean;
    onInverterDetailsChange: (inverterDetails: Record<string, InverterDetails>) => void;
}

const EditInvertersStringsContainer: React.FC<EditInvertersStringsContainerProps> = ({
    invertersAmount,
    totalStrings,
    firstInverterNumber,
    inverterDetails,
    isEditing,
    onInverterDetailsChange,
}) => {
    const [localInverterDetails, setLocalInverterDetails] = useState<
        Record<string, InverterDetails>
    >(inverterDetails || {});

    useEffect(() => {
        setLocalInverterDetails(inverterDetails || {});
    }, [inverterDetails]);

    const handleStringsChange = (inverterNumber: number, strings: number[]) => {
        const updatedDetails: Record<string, InverterDetails> = {
            ...localInverterDetails,
            [inverterNumber]: {
                unavailableStrings: strings,
            },
        };
        setLocalInverterDetails(updatedDetails);
        onInverterDetailsChange(updatedDetails);
    };

    // Gera array de números dos inversores
    const inverterNumbers = Array.from(
        { length: invertersAmount },
        (_, i) => firstInverterNumber + i
    );

    if (invertersAmount === 0 || totalStrings === 0) {
        return null;
    }

    return (
        <Grid
            container
            sx={{
                padding: "20px",
                flexDirection: "column",
                backgroundColor: "rgba(217, 217, 217, 0.1)",
                borderRadius: 2,
                marginTop: "8px",
                marginBottom: "8px",
                width: "100%",
                flexWrap: "nowrap"
            }}
        >
            <Grid item xs={12} sx={{ marginBottom: "16px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 600 }}>
                    Strings Desativadas por Inversor
                </Typography>
                <Typography variant="body2" sx={{ fontSize: "12px", color: "text.secondary", marginTop: "4px" }}>
                    Selecione as strings que estão desativadas em cada inversor
                </Typography>
            </Grid>

            {inverterNumbers.map((inverterNumber) => (
                <EditInverterStrings
                    key={inverterNumber}
                    inverterNumber={inverterNumber}
                    totalStrings={totalStrings}
                    unavailableStrings={
                        localInverterDetails[inverterNumber]?.unavailableStrings || []
                    }
                    isEditing={isEditing}
                    onStringsChange={handleStringsChange}
                />
            ))}
        </Grid>
    );
};

export default EditInvertersStringsContainer;
